// extracted by mini-css-extract-plugin
export default {"wrapper":"H3obICB78D","capture":"g97ZCnwYHW","capture-wrapper":"p9Gx_d5N7n","captureWrapper":"p9Gx_d5N7n","video":"t9GTOqweyA","msg":"d30ct7l03c"};